export default __webpack_public_path__ + "static/rbds-fb36a22c2cc333bb6bcf6dd7c46ec126.mp4";